<template>
  <v-container fluid>
    <v-row>
      <dataset-crud
        title="Gestion des Bin"
        :dataset="$store.state.bin_mapping"
      ></dataset-crud>
    </v-row>
  </v-container>
</template>

<script>
import DatasetCrud from '@/components/hmd/Dataset/DatasetCrud'
export default {
  components: {
    DatasetCrud,
  },
  name: 'Bin Mapping',
}
</script>

<style>
.v-data-table__wrapper {
  border-radius: 8px !important;
}
</style>
